import { bool } from "prop-types";
import { observer } from "mobx-react";
import {
  useEstimateEditorSettings,
  usePresetFieldNames,
  useEstimateEditorStore,
  useEstimateStructure,
  useVisibilityModeCellClassName,
  TimelineSettings,
  ValueCell,
  VisibilityButton,
} from "@tools";
import Grid from "@material-ui/core/Grid";

export const TimeCell = observer(({
  extendPadding,
  ...cellProps
}) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  const { hideSummaryTime } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideSummaryTime);
  
  return (
    <ValueCell
      size="large"
      isHeader
      className={className}
      style={{ cursor: allowEdition && "grab" }}
      extendPadding={extendPadding || allowEdition || visibilityMode}
      { ...cellProps }
    >
      <span className="preset-tableSummaryHeader pt-timeMta">
        { getFieldName("pt-timeMta") }
      </span>
      <Grid
        item container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="absolute w-max"
        style={{ right: -16 }}
      >
        {
          allowEdition &&
          <TimelineSettings
            useWeekMonthSwitch
            className="noDrag text-sm"
          />}
        {
          visibilityMode &&
          <VisibilityButton
            size="tiny"
            inColumn
            right={-8}
            hidden={hideSummaryTime}
            onChange={structure.visibility.setHideSummaryTime}
          />
        }
      </Grid>
    </ValueCell>
  )
})

TimeCell.propTypes = {
  extendPadding: bool,
}